import React, { useEffect, useState } from "react";
import gallery2 from "../../assets/images/Galéria 2.jpg";
import gallery3 from "../../assets/images/Galéria 3.jpg";
import gallery4 from "../../assets/images/Galéria 4.jpg";
import gallery6 from "../../assets/images/Galéria 6.jpg";
import gallery7 from "../../assets/images/Galéria 7.jpg";
import gallery8 from "../../assets/images/Galéria 8.jpg";
import gallery9 from "../../assets/images/Galéria 9.jpg";
import gallery10 from "../../assets/images/Galéria 10.jpg";
import gallery11 from "../../assets/images/Galéria 11.jpg";
import gallery12 from "../../assets/images/Galéria 12.jpg";
import SectionHeading from "../shared/SectionHeading";
import "./GallerySection.css";

const galleryImages = [
  gallery2,
  gallery3,
  gallery4,
  gallery6,
  gallery7,
  gallery8,
  gallery9,
  gallery10,
  gallery11,
  gallery12,
];

function GallerySection() {
  const [activeGalleryIndex, setActiveGalleryIndex] = useState<number | null>(
    null,
  );

  const closeGallery = () => {
    setActiveGalleryIndex(null);
  };

  const showPreviousImage = () => {
    setActiveGalleryIndex((currentIndex) => {
      if (currentIndex === null) {
        return currentIndex;
      }

      return (currentIndex - 1 + galleryImages.length) % galleryImages.length;
    });
  };

  const showNextImage = () => {
    setActiveGalleryIndex((currentIndex) => {
      if (currentIndex === null) {
        return currentIndex;
      }

      return (currentIndex + 1) % galleryImages.length;
    });
  };

  useEffect(() => {
    if (activeGalleryIndex === null) {
      document.body.style.overflow = "";
      return undefined;
    }

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        closeGallery();
      }

      if (event.key === "ArrowLeft") {
        showPreviousImage();
      }

      if (event.key === "ArrowRight") {
        showNextImage();
      }
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [activeGalleryIndex]);

  return (
    <>
      <section className="section" id="galeria">
        <SectionHeading
          eyebrow="Galéria"
          title="Részletek a kezelésekből és a rendelő hangulatából"
          centered
        />

        <div className="gallery-grid">
          {galleryImages.map((image, index) => (
            <figure className="gallery-card" key={image}>
              <button
                className="gallery-card__button"
                type="button"
                onClick={() => setActiveGalleryIndex(index)}
                aria-label={`Galéria kép megnyitása ${index + 1}`}
              >
                <img
                  src={image}
                  alt={`Galéria ${index + 1}`}
                  loading="lazy"
                  decoding="async"
                />
              </button>
            </figure>
          ))}
        </div>
      </section>

      {activeGalleryIndex !== null ? (
        <div
          className="gallery-lightbox"
          role="dialog"
          aria-modal="true"
          aria-label="Galéria nagy képnézet"
          onClick={closeGallery}
        >
          <div
            className="gallery-lightbox__content"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              className="gallery-lightbox__close"
              type="button"
              onClick={closeGallery}
              aria-label="Bezárás"
            >
              ×
            </button>

            <button
              className="gallery-lightbox__nav gallery-lightbox__nav--prev"
              type="button"
              onClick={showPreviousImage}
              aria-label="Előző kép"
            >
              ‹
            </button>

            <figure className="gallery-lightbox__figure">
              <img
                src={galleryImages[activeGalleryIndex]}
                alt={`Galéria ${activeGalleryIndex + 1}`}
              />
              <figcaption>
                {activeGalleryIndex + 1} / {galleryImages.length}
              </figcaption>
            </figure>

            <button
              className="gallery-lightbox__nav gallery-lightbox__nav--next"
              type="button"
              onClick={showNextImage}
              aria-label="Következő kép"
            >
              ›
            </button>
          </div>
        </div>
      ) : null}
    </>
  );
}

export default GallerySection;
